export default function(data) {
  var self = this;

  self.maxFilesize = Kadenze.isKadenze ? 2000 : 500;

  /*------------------------------------------------GRADING POLICY--------------------------------------------------*/
  self.grading_policy_entries = ko.observableArray();
  self.oldPolicyWeight = ko.observable();

  self.grading_policy_mapping = {
    update: function(options) {
      var vm = ko.mapping.fromJS(_.extend(options.data, {
        saved: ko.observable(true),
        editing: ko.observable(options.data.editing || false),
        select_from_preset: ko.observable(options.data.select_from_preset || false), color: ko.computed(function () {
          var policy_index = self.grading_policy_entries.indexOf(vm);
          var color_index = policy_index % Kadenze.COLORS.length;
          return Kadenze.COLORS[color_index];
        })
      }));
      vm.client_errors = null;
      vm.isValid = ko.computed(function () {
        vm.client_errors = ko.validation.group(vm, { deep: true });
        return (vm.client_errors().length == 0);
      });
      vm.editing.subscribe(function (value) {
        vm.saved(false);
        self.saveGradingPolicy(vm);
      });
      vm.selected_preset = ko.computed({
        read: function () {
          return vm.grading_policy_preset_id();
        },
        write: function (id) {
          if (!isNaN(parseInt(id))) {
            if (id == -1) {
              vm.select_from_preset(false);
              vm.grading_policy_preset_id(null);
            } else {
              var selected = _.find(self.course().grading_policy_presets(), function (preset) {
                return preset.id() == id;
              });
              vm.grading_policy_preset_id(selected.id());
              vm.name(selected.name());
              vm.editing(false);
            }
          }
        }
      });
      vm.otherPolicyNames = ko.computed(function () {
        return _.map(self.grading_policy_entries(), function (entry) {
          return entry.name();
        });
      });
      vm.name.extend({ required: true, maxLength: 30, isUnique: {
        params: {
          array: vm.otherPolicyNames,
          predicate: function (opt, selectedVal) {
            return opt && (opt.toLowerCase().trim() === selectedVal.toLowerCase().trim());
          }
        },
        onlyIf: function() { return !vm.saved(); },
        message: 'This policy name is already taken'
      } });
      return vm;
    }
  };
  self.saveGradingPolicy = function (policy) {
    if (policy.isValid() && !policy.editing()) {
      var data = {};
      data.grading_policy_entry = ko.mapping.toJS(policy);
      var request = new Kadenze.AjaxRequest({
        type: policy.id() ? 'PATCH' : 'POST',
        url: policy.id() ? Kadenze.Routes.course_grading_policy_entry_path(self.course().id(), policy.id()) : Kadenze.Routes.course_grading_policy_entries_path(self.course().id()),
        data: data,
        timeout: 60000
      });

      request.done(function(response, status, xhr) {
        var entry = ko.mapping.fromJSON(response.entry);
        policy.id(entry.id());
        policy.saved(true);
      });

      request.fail(function(xhr, status, msg) {
        policy.editing(true);
        new Kadenze.Notice.error({message: xhr.responseJSON.errors});
      });
    } else {
      policy.client_errors.showAllMessages(true);
    }
  };
  self.onEnterCustomPolicy = function (item, event) {
    if (event.keyCode === 13) {
      item.editing(false);
    }
    return true;
  };
  self.onEnterWeight = function (item, event) {
    if (event.keyCode === 13) {
      event.stopPropagation();
    } else {
      return true;
    }
  };
  self.addGradingPolicy = function (item, event) {
    var policy = {id: null, course_id: self.course().id(), name: null, weight: 0, color: '',
      grading_policy_preset_id: null, required: false, editing: true, select_from_preset: true};
    var mapped_policy = ko.mapping.fromJS(policy, self.grading_policy_mapping);
    self.grading_policy_entries.push(mapped_policy);
    event.stopPropagation();
  };
  self.editGradingPolicy = function (item, event) {
    if (!item.required()) {
      item.editing(true);
    }
    event.stopPropagation();
  };
  self.deleteGradingPolicy = function (item, event) {
    if (item.required()) {
      new Kadenze.Notice.error({message: item.name() + ' policy is required by the admins and cannot be deleted.'});
    } else if (item.id()) {
      var request = new Kadenze.AjaxRequest({
        type: 'DELETE',
        url: Kadenze.Routes.course_grading_policy_entry_path(self.course().id(), item.id()),
        data: null,
        timeout: 60000
      });

      request.done(function(response, status, xhr) {
        self.grading_policy_entries.remove(item);
        new Kadenze.Notice.success({});
      });

      request.fail(function(xhr, status, msg) {
        new Kadenze.Notice.error({message: xhr.responseJSON.errors});
      });
    } else {
      self.grading_policy_entries.remove(item);
    }
  };
  self.isPolicyPresetUsed = function (item, event) {
    return (_.findIndex(self.grading_policy_entries(), function (entry) { return entry.grading_policy_preset_id() == item.id(); }) > -1);
  };
  self.stopPropagation = function (item, event) {
    event.stopPropagation();
  };
  self.setupGradingPolicyFocusHack = function () {
    //This is used in place of a foucusout/blur event for select pickers
    $(window).click(function(e) {
      _.each(self.grading_policy_entries(), function (entry) {
        if (entry.editing() && !isNaN(parseInt(entry.grading_policy_preset_id()))) {
          entry.editing(false);
        }
      });
    });
  };
  self.totalPolicyWeight = function() {
    if (self.grading_policy_entries) {
      var total = _.reduce(self.grading_policy_entries(), function(memo, entry){ return memo + entry.weight(); }, 0);
    }
    return total || 0;
  };
  self.showPolicyWeightWarning = function () {
    if (self.oldPolicyWeight() <= 100 && self.totalPolicyWeight() > 100) {
      new Kadenze.Notice.attention($.extend({}, self.defaultNoticeOptions, {message: 'Your grading policy currently allows a maximum grade of over 100%.' }));
    }
    self.oldPolicyWeight(self.totalPolicyWeight());
  };

  self.initGradingPolicyBreakdownChart = function() {
    var getStackedBarChartDatasets = function () {
      var unsortedArr = _.map(self.grading_policy_entries(), function(entry) {
        var datasetObj = {
          label: entry.name(),
          data: [parseInt(entry.weight())],
          backgroundColor: entry.color(),
          borderColor: '#ffffff',
          borderWidth: 1
        };
        return datasetObj;
      });
      return _.sortBy(unsortedArr, function(obj){return obj.data[0];}).reverse();
    };

      // STACKED BAR CHART ----------------------------------------------------------- //
    var stackedBarChartElement = document.getElementById('chartjs-stacked-bar');
    if (stackedBarChartElement) {
      var datasetsArr = getStackedBarChartDatasets();
      var stackedBar = new Chart(stackedBarChartElement, {
        type: 'bar',
        data: {
          labels: [],
          datasets: datasetsArr
        },
        options: {
          legend: {
            display: false
          },
          maintainAspectRatio: false,
          scales: {
            yAxes: [{
              stacked: true,
              ticks: {
                beginAtZero:true
              }
            }],
            xAxes: [{
              stacked: true,
              display: false
            }]
          },
          tooltips: {
            titleSpacing: 0,
            xPadding: 15,
            callbacks: {
              label: function(tooltipItem, data){
                return data.datasets[tooltipItem.datasetIndex].label + ': ' + tooltipItem.yLabel + '%';
              }
            }
          }
        }
      });
      ko.computed(function() {
        ko.mapping.toJSON(self.grading_policy_entries());
        var datasetsArr = getStackedBarChartDatasets();
        stackedBar.data.datasets = datasetsArr;
        stackedBar.update(0);
      });
    }
  };
  /*------------------------------------------------/GRADING POLICY-------------------------------------------------*/
  self.sessions = ko.observableArray();
  self.terms = JSON.parse($('#terms_json').val());

  self.defaultNoticeOptions = {
    parentObject: '.instructor-edit--sidebar',
    method: 'append'
  };

  self.savedAt = ko.observable(false);
  self.dummyBool = ko.observable(true); //used to force computed observable to update
  self.saving = ko.observable(false);

  self.status = ko.observable(JSON.parse(data).status);
  this.isDraft = ko.observable(JSON.parse(data).isDraft);
  this.isPublished = ko.observable(JSON.parse(data).isPublished);

  self.edit = function(item, event) { item.editing(true); };
  self.isAddingSection = ko.observable(false);

  self.newSection = {
    title: ko.observable().extend({required: true}),
    content: ko.observable(),
    id: ko.observable(),
    order: ko.observable(),
    isNew: true
  };

  self.savedAtText = ko.computed(function() {
    self.dummyBool();
    if ( self.saving() ) {
      return Kadenze.I18n.t('dict.saving');
    }
    else if ( self.savedAt() ) {
      return Kadenze.I18n.t('dict.last_saved_at') + ' ' + moment(self.savedAt()).fromNow();
    }
    else {
      return '';
    }
  });

  self.topicsSource = function(query, cb) {
    var filteredList = $.grep(self.available_topics(), function (item, index) {
      return item.name().toLowerCase().match(query.toLowerCase());
    });

    var mapped = $.map(filteredList, function (item) { return {name: item.name() }; });
    cb(mapped);
  };

  self.addNewSection = function() {
    self.newSection.title(null);
    self.newSection.title.isModified(false);
    self.newSection.content(null);
    var maxOrder = Math.max.apply(null, _.map(self.course().syllabus_sections(), function(section){
      return Math.max(section.order(), -1);
    })) || -1;
    self.newSection.order(maxOrder + 1);
    self.isAddingSection(true);
  };

  self.cancelNewSection = function() {
    self.isAddingSection(false);
  };

  self.saveNewSection = function(skipSave) {
    var clientErrors = ko.validation.group(self.newSection.title);
    if (clientErrors().length === 0 || (clientErrors().length === 1 && clientErrors()[0] === null)) {
      self.course().syllabus_sections.push(self.newSection);
      self.cancelNewSection();
      if (skipSave !== true) {
        self.saveDraft();
      }
    } else {
      clientErrors.showAllMessages();
      new Kadenze.Notice.error($.extend({}, self.defaultNoticeOptions, { message: 'Please fix all validation errors before saving.' }));
      return false;
    }
    return true;
  };

  self.removeSection = function(id) {
    return function() {
      var sections = self.course().syllabus_sections();
      var index = -1;
      var existing = null;
      _.each(sections, function(section, _index){
        if (section.id() == id) {
          index = _index;
          existing = section;
        }
      });
      if (index > -1) {
        existing._destroy = true;
        sections[index] = existing;
        self.course().syllabus_sections(sections);
        self.saveDraft();
      }
    };
  };

  self.removeSyllabusFile = function() {
    self.course().syllabus_file.url(null);
    self.course().syllabus_file_path(null);
  };

  self.initTopicsTypeahead = function() {
    var $ele = $('#topic_names');
    if ($ele.length > 0) {
      var tagsinput = $ele.tagsinput({
        confirmKeys: [9, 13, 188],
      });
      $ele.tagsinput('input').blur(function() {
        $ele.tagsinput('add', $(this).val());
        $(this).val('');
      });

      $('.bootstrap-tagsinput input', $ele.parent()).typeahead({
        minLength: 0,
        hint: false,
        highlight: false
      }, {
        name: 'noname',
        displayKey: 'name',
        source: self.topicsSource
      }).bind('typeahead:selected', $.proxy(function (obj, datum) {
        $ele.tagsinput('add', datum.name);
      }));

      $('.bootstrap-tagsinput input', $ele.parent()).bind('typeahead:opened', function () {
        var ev = $.Event('keydown');
        ev.keyCode = ev.which = 40;
        $(this).trigger(ev);
        $(this).typeahead('val', '');
        return true;
      });
    }
  };


  self.prepEditCourseNameNumber = function() {
    self.course().name_edit(self.course().name());
    self.course().number_edit(self.course().number());
    $('#edit_course_name_number .modal').modal('show');
  };

  self.editCourseNameNumber = function(form){
    var errors = ko.validation.group([self.course().name_edit, self.course().number_edit]);
    if (errors().length == 0) {
      $('#edit_course_name_number .modal').modal('toggle');
      self.course().name(self.course().name_edit());
      self.course().number(self.course().number_edit());
      var selected_term = _.find(self.terms, function(term) { return term.id == self.course().term_id(); });
      if (selected_term)
        self.course().term_name(selected_term.name);
    }
  };

  self.dataForSaving = function(opts) {
    var obj = ko.mapping.toJS(self.course);

    obj.topic_names = self.course().topic_names;

    if (obj.start_date_string && obj.start_date_string.trim() !== '') {
      obj.start_date_string = Kadenze.Util.getMomentDateFromObservable(self.course().start_date_string).utc().format(Kadenze.I18n.t('date.formats.js_default_with_zone'));
    }

    if (obj.end_date_string && obj.end_date_string.trim() !== '') {
      obj.end_date_string = Kadenze.Util.getMomentDateFromObservable(self.course().end_date_string).utc().format(Kadenze.I18n.t('date.formats.js_default_with_zone'));
    }

    if (obj.enrollment_cutoff_date_string && obj.enrollment_cutoff_date_string.trim() !== '') {
      obj.enrollment_cutoff_date_string = Kadenze.Util.getMomentDateFromObservable(self.course().enrollment_cutoff_date_string).utc().format(Kadenze.I18n.t('date.formats.js_default_with_zone'));
    }

    obj.grading_policy_entries_attributes = ko.mapping.toJS(self.grading_policy_entries());
    obj.syllabus_sections_attributes = ko.mapping.toJS(self.course().syllabus_sections());

    obj.start_date = obj.start_date_string;
    obj.end_date = obj.end_date_string;

    // _.each(obj.lectures_attributes, function(item) {
    //     item.start_date_string = item.formatted_start_date;
    //     delete item.formatted_start_date;
    // });
    delete obj.grading_policy_entries;
    delete obj.lectures;
    delete obj.lectures_attributes;
    delete obj.coursework;
    delete obj.syllabus_sections;
    delete obj.settings;

    return $.extend(true, {}, {'course': obj}, opts);
  };

  self.saveDraft = function(isAutosave) {
    if (self.isAddingSection()) {
      var isValid = self.saveNewSection(true);
      if (!isValid) { return false; }
    }

    var errors = ko.validation.group(self.course)();

    if (errors.length > 0){
      new Kadenze.Notice.error({message: errors[0]});
      return false;
    }
    self.saving(true);
    // Build our object
    var data = self.dataForSaving();
    var type = 'POST';
    var url = Kadenze.Routes.courses_path();
    if (self.course().id()) {
      type = 'PUT';
      url = Kadenze.Routes.course_path(self.course().id());
    }

    if (isAutosave)
      delete(data.course.status)

    return $.ajax({
      type: type,
      url: url,
      data: data,
      dataType: 'json',
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      }
    }).success(function(data) {
      // Kadenze.UIUtil.showNotice($('#main-pjax-container'), data, 2000);
      self.savedAt(new Date());
      var courseData = JSON.parse(data.course);
      self.course().updated_at(courseData.updated_at);

      _.keys(self.course().visible_syllabus_sections).forEach( function(key) {
        if(courseData.visible_syllabus_sections[key]) {
          self.course().visible_syllabus_sections[key](courseData.visible_syllabus_sections[key]);
        }
      });
      self.course().syllabus_sections(ko.mapping.fromJS(courseData.syllabus_sections)());

      new Kadenze.Notice.success($.extend({}, self.defaultNoticeOptions, { message: Kadenze.I18n.t('notice.course.save_success') }));
      self.showPolicyWeightWarning();
    }).error(function(response) {
      console.warn('error saving course');
      console.debug(response);

      new Kadenze.Notice.error($.extend({}, self.defaultNoticeOptions, { message: response.responseJSON.errors }));
    }).always(function() {
      self.saving(false);
    });
  };

  self.publish = function() {
    if (self.isAddingSection()) {
      var isValid = self.saveNewSection(true);
      if (!isValid) { return false; }
    }
    self.saving(true);
    // Build our object
    var data = self.dataForSaving(),
      type = 'PATCH',
      url = Kadenze.Routes.publish_course_path(self.course().id());

    $.ajax({
      type: type,
      url: url,
      data: data,
      dataType: 'json',
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      }
    }).success(function(data) {
      // Kadenze.UIUtil.showNotice($('#main-pjax-container'), data, 2000);
      self.status('pending');
      self.savedAt(new Date());
      self.course().updated_at(data.course.updated_at);

      new Kadenze.Notice.success($.extend({}, self.defaultNoticeOptions, { message: data.message, persistent: true }));
      self.showPolicyWeightWarning();
    }).error(function(response) {
      console.debug(response);

      new Kadenze.Notice.error($.extend({}, self.defaultNoticeOptions, { message: response.responseJSON.errors }));
    }).always(function() {
      self.saving(false);
    });
  };

  self.deleteCourse = function() {
    var deleteCourse = function() {
      if (self.course().id()) {
        var type = 'DELETE';
        var url = Kadenze.Routes.course_path(self.course().id());
      } else {
        return false;
      }

      $.ajax({
        type: type,
        url: url,
        data: null,
        dataType: 'json',
        headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        }
      }).success(function(data) {
        new Kadenze.Notice.success($.extend({}, self.defaultNoticeOptions, { message: data.message, persistent: true }));
        window.location = data.redirect_path;
      }).error(function(response) {
        console.debug(response);
        new Kadenze.Notice.error($.extend({}, self.defaultNoticeOptions, { message: response.responseJSON.errors }));
      }).always(function() {

      });
    };

    Kadenze.UIUtil.confirmAction('Are you sure you want to delete this course? All sessions and coursework will also be destroyed.', deleteCourse);
  };

  self.preview = function() {
    var response = self.saveDraft();
    response.success(function() {
      window.location = Kadenze.Routes.course_info_path(self.course().slug(), {preview: true, exit_path: encodeURI(window.location.pathname)});
    });
  };

  self.initializeDropzone = function() {
    var $el = $('#course-img-dz').addClass('dz-unit');

    var msgText = Kadenze.I18n.t('course.logo.dropzone.add_image', 'en');
    var subMsgText = Kadenze.I18n.t('course.logo.dropzone.max_file_size', 'en');

    // var message = JST['templates/dropzone-imagefile']({
    //     message: msgText,
    //     subMessage: subMsgText
    // });
    var message = JST['templates/dropzone-generic']({
      title: Kadenze.I18n.t('course.logo.dropzone.course_logo', 'en'),
      maxFilesize: 10,
      optional: true,
      acceptedFiles: '.jpg, .jpeg, .png',
      dropFilesTitle: Kadenze.I18n.t('drop_file_editor.drop_file_title'),
      dragAndDrop: Kadenze.I18n.t('drop_file_editor.drag_and_drop'),
      browseFiles: Kadenze.I18n.t('drop_file_editor.browse_files'),
      dimentionLabel: Kadenze.I18n.t('drop_file_editor.dimensions_label'),
      maxFilesizeLabel: Kadenze.I18n.t('drop_file_editor.max_file_size'),
      fileTypesLabel: Kadenze.I18n.t('drop_file_editor.file_types'),
      optionalLable: Kadenze.I18n.t('drop_file_editor.optional'),
    });

    var opts = {
      maxFilesize: 10,
      maxThumbnailFilesize: 100,
      dzPreview: JST['templates/dropzone-generic-img-preview']({
        previewable: true,
        containerClass: 'dz-preview-wide',
        nameLabel: Kadenze.I18n.t('file_preview.name'),
        sizeLabel: Kadenze.I18n.t('file_preview.size'),
        previewLabel: Kadenze.I18n.t('file_preview.preview'),
        removeLabel: Kadenze.I18n.t('file_preview.remove_file'),
        fileUploadProgressLabel: Kadenze.I18n.t('file_preview.file_upload_progress'),
      }),
      previewable: true,
      acceptedFiles: '.jpg, .jpeg, .png',
      cropOptions: {
        modalId: 'crop_modal'
      },
      autoProcessQueue: false
    };

      // var message = JST['templates/course_logo_dropzone_placeholder']();
      // message = Kadenze.I18n.tt(message, 'en');

    var uploadURL = Kadenze.Routes.temp_image_upload_path();
    var $removeInput = $('#course_logo_remove');

    var callbacks = {
      thumbnail: function(file, data){},
      sending: function( file, xhr, formData ){},
      success: function(file, response){
        self.course().logo_path(response.path);
        self.course().remove_logo(false);
      },
      error: function(file, errorMessage){
        new Kadenze.Notice.error({ message: errorMessage });
        $('#course-img-dz')[0].dropzone.removeAllFiles();
      },
      complete: function(file){},
      addedfile: function(file){},
      removedfile: function(file){
        $removeInput.val('1');
        self.course().remove_logo(true);
        self.course().logo_path(null);
      }
    };

    var curFileObj;
    curFileObj = {
      name: self.course().logo_file_name(),
      size: self.course().logo_file_size(),
      path: self.course().logo.url()
    };
    var courseDZ = new Kadenze.ImageDropZone($el, message, uploadURL, callbacks, curFileObj, opts );

  };

  self.initializePDFDropzone = function() {
    var $el = $('#syllabus-pdf-dz');
    $el.addClass('dz-unit');

    var msgText = `${Kadenze.I18n.n('syllabus')} file`;

    var acceptedFiles = '.pdf';
    var subMsgText = acceptedFiles;

    var message = JST['templates/dropzone-media-message']({
      title: msgText,
      maxFilesize: 10,
      fileTypes: acceptedFiles,
      dropTitle: Kadenze.I18n.t('drop_file_editor.drop_title'),
      fileHere: Kadenze.I18n.t('drop_file_editor.file_here'),
      browseFiles: Kadenze.I18n.t('drop_file_editor.browse_files'),
      or: Kadenze.I18n.t('dict.or'),
      fileTypesTitle: Kadenze.I18n.t('drop_file_editor.file_types'),
      maxSizeLabel: Kadenze.I18n.t('drop_file_editor.max_file_size'),
    });

    var uploadURL = Kadenze.Routes.temp_image_upload_path();
    var previewTemplate = JST['templates/dropzone-media-preview']({ previewable: false });

    var opts = {
      url: uploadURL,
      maxFilesize: 10,
      maxFiles: 1,
      paramName: 'file',
      acceptedFiles,
      previewTemplate,
      autoProcessQueue: true,
      previewable: false,
      playable: false,
      accept: function(file, done) {
        if (file.size === 0) {
          done('Please make sure file is not empty.');
        } else { done(); }
      },
    };

    var $imageInput = $('#syllabus_file_path');
    var $removeInput = $('#syllabus_file_remove');

    var callbacks = {
      uploadprogress: function(file, progress, bytesSent) {
        $('.media-upload-progress-bar', file.previewTemplate).css('width', progress + '%');
      },
      thumbnail: function(file, data){},
      sending: function( file, xhr, formData ){},
      success: function(file, response){
        $('.media-upload-progress-bar-container', file.previewTemplate).hide();
        self.course().syllabus_file_path(response.path);
        self.course().remove_syllabus_file(false);
      },
      error: function(file, errorMessage){
        new Kadenze.Notice.error({ message: errorMessage });
        $('#syllabus-pdf-dz')[0].dropzone.removeAllFiles();
      },
      complete: function(file){},
      addedfile: function(file){},

      removedfile: function(file){
        $imageInput.val('');
        $removeInput.val('1');
        self.course().syllabus_file_path('');
        self.course().remove_syllabus_file(true);
      },
      maxfilesexceeded: function() { }
    };

    var curFileObj;
    if ($imageInput.length > 0) {
      curFileObj = {
        path: self.course().syllabus_file_path(),
        name: self.course().syllabus_file_name(),
        type: 'pdf',
        size: self.course().syllabus_file_info.size()
      };
    }

    var pdfDZ = new Kadenze.MediaDropZone($el, $(message), opts, callbacks, false, curFileObj );
  };

  self.initPromoDropzone = function() {
    var curVid = self.course().course_promo_video;
    if (!curVid || !curVid()) {
      var $el = $('#course-promo-dz');
      if ($el.length && !$el[0].dropzone) {
        $el.addClass('dz-unit');
        var mediaDZ;
        var msgText = Kadenze.I18n.t('course.promo_video.dropzone.add_video', 'en');
        var acceptedFiles = '.mp4, .mov, .m4v, .avi';
        var message = JST['templates/dropzone-media-message']({
          title: msgText,
          fileTypes: acceptedFiles,
          maxFilesize: self.maxFilesize,
          dropTitle: Kadenze.I18n.t('drop_file_editor.drop_title'),
          fileHere: Kadenze.I18n.t('drop_file_editor.file_here'),
          browseFiles: Kadenze.I18n.t('drop_file_editor.browse_files'),
          or: Kadenze.I18n.t('dict.or'),
          fileTypesTitle: Kadenze.I18n.t('drop_file_editor.file_types'),
          maxSizeLabel: Kadenze.I18n.t('drop_file_editor.max_file_size'),
        }
        );

        var previewTemplate = JST['templates/dropzone-media-preview']({status: 'Uploading...'});

        var opts = {
          url: Kadenze.Routes.course_course_promo_videos_path(self.course().id()),
          previewTemplate: previewTemplate,
          autoProcessQueue: true,
          paramName: 'course_promo_video[media_src]',
          acceptedFiles: acceptedFiles,
          maxFilesize: self.maxFilesize,
          maxFiles: 1
        };

        var callbacks = {
          addedfile: function(file) {
          },
          success: function(file, response) {
            $('.media-upload-progress-bar-container', file.previewTemplate).hide();
            self.course().course_promo_video(ko.mapping.fromJS(response.files[0].course_promo_video));
            $el[0].dropzone.removeAllFiles();
            $el[0].dropzone.emit('reset');
            self.clearSubtitleDropzone();
            self.initializeSubtitleDropzone();
          },
          uploadprogress: function(file, progress, bytesSent) {
            $('.media-upload-progress-bar', file.previewTemplate).css('width', progress + '%');
          },
          sending: function(file, response, formData) {
            // formData.append('coursework_field_entry[coursework_field_id]', entry.coursework_field_id());
          },
          error: function(file, errorMessage) {
            new Kadenze.Notice.error({ parentObject: $el, message: errorMessage });
          },
          complete: function(file) {
          },
          removedfile: function(file) {
            //TODO: Delete the file from the server/db
            // self.entryIds.remove(file.id);
          }
        };

          // Check to remove duplicate DZ
        if ((curVid || curVid()) && ($el.children().length !== 1)){
          mediaDZ = new Kadenze.MediaDropZone($el, $(message), opts, callbacks, false);
        } else{
          $el.children().remove();
          mediaDZ = new Kadenze.MediaDropZone($el, $(message), opts, callbacks, false);
        }

      }
    }
  };

  self.removePromoVideo = function(element) {
    var vid = self.course().course_promo_video();

    var request = new Kadenze.AjaxRequest({
      type: 'DELETE',
      url: Kadenze.Routes.course_course_promo_video_path(self.course().slug(), vid.id())
    });

    self.course().course_promo_video(null);
    self.initPromoDropzone();
  };

  self.showAddSubtitlesPane = function() {
    var $button = $('.media-btn__add-subtitles');
    var $pane = $('#add-promo-subs');
    var isClosed = $button.hasClass('closed');

    var class_remove = isClosed == true ? 'closed' : 'open';
    var class_add = isClosed == true ? 'open' : 'closed';
    $button.removeClass(class_remove).addClass(class_add);

    if(isClosed) {
      $pane.show();
    }
    else {
      $pane.hide();
    }
  };

  self.initializeSubtitleDropzone = function() {
    var $dzWrapper = $('#promo-subtitles-dz');
    var $dzSrcLang = $('#promo-subtitles-select');
    var media = self.course().course_promo_video();

    var fileTypes = '.vtt';
    var message = JST['templates/dropzone-standard-message']({
      title: Kadenze.I18n.t('session.media.subtitles_dropzone_prompt'),
      fileTypes: fileTypes
    }
    );

    var $previewTemplate = $(Kadenze.I18n.tt(JST['templates/dropzone-session-media-preview']({status: 'uploading'})));
    $previewTemplate.css('display', 'none'); //hack to hide preview (dropzone limitation)

    var opts = {
      url: Kadenze.Routes.subtitles_path(),
      previewsContainer: '#promo-video-container',
      previewTemplate: $previewTemplate[0].outerHTML,
      autoProcessQueue: true,
      paramName: 'subtitle[src_file]',
      acceptedFiles: '.vtt',
      maxFiles: 1,
      clickable: true,
      accept: function(file, done) {
        //check for duplicate subtitles
        var srcLang = $dzSrcLang.val();

        var found = _.find(media.subtitles(), function(subtitle) {
          return subtitle.srclang() === srcLang;
        });

        subtitleDZ.options.method = 'POST';
        subtitleDZ.options.url = Kadenze.Routes.subtitles_path();

        if(found) {
          Kadenze.UIUtil.confirmAction(
            Kadenze.I18n.t('session.media.confirm_update_subtitles'),
            function confirmed() {
              subtitleDZ.options.method = 'PUT';
              subtitleDZ.options.url = Kadenze.Routes.subtitle_path(found.id());
              done();
            },
            function cancelled() {
              done('cancelled');
            }
          );
        }
        else {
          done();
        }
      }
    };

    var callbacks = {
      sending: function(file, xhr, formData) {
        var srcLang = $dzSrcLang.val();
        var srcLabel = $dzSrcLang.find('option:selected').text();

        formData.append('subtitle[srclang]', srcLang);
        formData.append('subtitle[label]', srcLabel);
        formData.append('subtitle[subtitleable_id]', media.id());
        formData.append('subtitle[subtitleable_type]', 'CoursePromoVideo');

        //check for duplicate subtitles
        var found = _.find(media.subtitles(), function(subtitle) {
          return subtitle.srclang() === srcLang;
        });

        if(found) {
          //update instead of new:
          formData.append('subtitle[id]', found.id());
        }
      },
      success: function(file, response) {
        self.updateClientWithSubtitle(response, media);
      },
      error: function(file, errorMessage) {
        if(errorMessage != 'cancelled') {
          new Kadenze.Notice.error({parentObject: $dzWrapper, message: errorMessage});
        }
      },
      complete: function(file) {
        subtitleDZ.removeFile(file);
      }
    };

    var subtitleDZ = new Kadenze.MediaDropZone($dzWrapper, $(message), opts, callbacks, false);
  };

  self.clearSubtitleDropzone = function() {
    $('#promo-subtitles-dz').empty();
  };

  //add/update ko vm with subtitle
  self.updateClientWithSubtitle = function(response) {
    var media = self.course().course_promo_video();
    var koNewSub = ko.mapping.fromJS(response.subtitle);

    //new or existing?
    var found = _.find(media.subtitles(), function(subtitle) {
      return subtitle.id() === koNewSub.id;
    });

    if (found) {
      media.subtitles.replace(found, koNewSub);
    } else {
      media.subtitles.push(koNewSub);

      const opts = { src: koNewSub.src_file.url() };

      if(koNewSub.srclang() === 'en')
        opts.default = 'default'
    }
  };

  self.deleteSubtitles = function(subtitle) {
    var media = self.course().course_promo_video();
    //first delete from server
    Kadenze.UIUtil.confirmAction(
      Kadenze.I18n.t('session.media.confirm_delete_subtitles'),
      function() {
        //post it
        var request = new Kadenze.AjaxRequest({
          method: 'DELETE',
          url: Kadenze.Routes.subtitle_path(subtitle.id())
        });

        request.done(function(response) {
          //remove from view model
          media.subtitles.remove(subtitle);

          //remove from renderer
          // media.renderer().removeTextTrack(subtitle.label());
        });

        request.fail(function(xhr, textStatus, errorThrown) {
          new Kadenze.Notice.error({
            parentObject: $('#session-media-dz').parent(),
            message: xhr.responseJSON.message
          });
        });
      }
    );
  };

  /* --- */
  self.courseworkList = function(session) {
    var names = _.map(session.existing_coursework(), function(cw) {
      return cw.name();
    });
    return names.length > 0 ? names.join(', ') : Kadenze.I18n.t('dict.none').capitalize_first();
  };

  self.updateSavedTime = function() {
    self.dummyBool(!self.dummyBool());
  };

  self.initSortable = function() {
    $('#js-custom-syllabus-sections').sortable({
      items: '.row',
      handle: '.syllabus-section__move',
      update: function(e, ui) {
        self.saving(true);
        new Kadenze.AjaxRequest({
          url: Kadenze.Routes.reorder_syllabus_sections_course_path(self.course().id()),
          type: 'PATCH',
          data: $(this).sortable('serialize'),
          dataAsJSON: false,
          success: function(data) {
            self.savedAt(new Date());
            new Kadenze.Notice({
              title: 'Successfully reordered syllabus sections.',
              type: 'success',
            });
          },
          complete: function () {
            self.saving(false);
          }
        });
      }
    });
  };

  const __construct = function(that) {
    console.log('constructor called for CourseInfoEditViewModel');
    var mapping = {
      'create': function(options) {
        var subMap = {
          'lectures': {
            'update': function(options) {
              return ko.mapping.fromJS(_.extend(options.data, {
                'editing': ko.observable(false)
              }));
            }
          },
          'grading_policy_entries': self.grading_policy_mapping,
          'course_promo_video': {
            'update': function(options) {
              if (options.data) {
                return ko.observable(ko.mapping.fromJS(options.data));
              }
            }
          }
        };
        return ko.mapping.fromJS(_.extend(options.data, {
          'remove_logo': false,
          'remove_syllabus_file': false
        }), subMap);
      }
    };

    that.course = ko.observable(ko.mapping.fromJSON(data, mapping));
    // map dates from server to avoid timezone conflict issues
    that.course().start_date_string(that.course().start_date());
    that.course().end_date_string(that.course().end_date());
    that.coursework = that.course().coursework;
    that.sessions = that.course().lectures;
    that.available_topics = that.course().available_topics;
    that.grading_policy_entries(that.course().grading_policy_entries());
    that.initializeDropzone();
    that.initializePDFDropzone();
    if(self.course().syllabus_file_path()) {
      $('#syllabus-pdf-dz .media-upload-progress-bar-container').hide();
    }

    that.initSortable();
    that.initPromoDropzone();

    if (that.course().course_promo_video() !== undefined) {
      that.initializeSubtitleDropzone();
    }

    that.savedAt(that.course().updated_at());

    $('#add_session').click(function(evt) {
      Kadenze.UIUtil.confirmAction(Kadenze.I18n.t('course.edit.leave_course_edit'), function(){
        $.when(self.saveDraft()).then(function(data, status, xhr){
          window.location = evt.target.href;
        });
      });
      return false;
    });

    //Hack to make edit-in-place UX work with select pickers
    self.setupGradingPolicyFocusHack();
    self.initGradingPolicyBreakdownChart();
    self.oldPolicyWeight(self.totalPolicyWeight());

    setTimeout(self.initTopicsTypeahead, 1000);

    Kadenze.Timers.push(setInterval(self.updateSavedTime, 1000));

  }(this);
}

